// ThemeContext.js
import React, { createContext, useState, useEffect } from "react";
import {
  initializeTheme,
  setThemeGlobally,
  getCurrentTheme,
} from "./utilsThemeLogic";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getCurrentTheme());

  useEffect(() => {
    initializeTheme();
    setTheme(getCurrentTheme());
  }, []);

  const changeTheme = (newTheme) => {
    setThemeGlobally(newTheme);
    setTheme(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, changeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
